import { Component } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { UserInfoService } from 'src/app/shared/services/UserInfoService/user-info.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-courses',
  templateUrl: './my-courses.component.html',
  styleUrls: ['./my-courses.component.css']
})
export class MyCoursesComponent {
  userId = '';
  courses: any[] = [];
  language!: string;

  // Static metadata keyed by course `name` from API
  private courseStaticData: Record<string, { titleTr: string; summary: string; imageIconPath: string; imageAlt: string }> = {
    'dictation-course': {
      titleTr: 'أسرار كتابة الهمزة',
      summary: 'كورس شامل لتعلم أسرار كتابة الهمزة في أول ووسط وآخر الكلمة وعلى نبرة، مع تبسيط قواعد النحو والإعراب خطوة بخطوة حتى الإتقان بأسلوب سهل وممتع.',
      imageIconPath: './assets/Al-Bershama/media/homeComponents/service/dictation2.webp',
      imageAlt: 'dictation-icon'
    },
    'grammar-course': {
      titleTr: 'أسرار الإعراب والاستخراج للمبتدئين',
      summary: 'نصحبك من خلال هذا الكورس في رحلة ممتعة داخل عقلك فلن تشعر بالملل تعلم قواعد النحو من البداية حتى الإتقان تعلم أسرار الإعراب خطوة بخطوة من البداية حتى الإتقان.',
      imageIconPath: './assets/Al-Bershama/media/homeComponents/service/grammar2.webp',
      imageAlt: 'grammar-icon'
    },
    'grammar-dictation-course': {
      titleTr: 'أسرار كتابة الهمزة والإعراب للمبتدئين',
      summary: 'كورس شامل لتعلم قواعد النحو والإعراب والاستخراج من البداية حتى الإتقان، بأسلوب مبسط مع أمثلة ونماذج محلولة، لمساعدتك على إنهاء مشاكلك مع النحو بسهولة.',
      imageIconPath: './assets/Al-Bershama/media/homeComponents/service/grammar-dictation.webp',
      imageAlt: 'grammar-dictation-icon'
    }
  };

  constructor(
    private userService: UserService,
    private userInfoService: UserInfoService,
    private router: Router
  ) {
    this.userId = this.userInfoService.getUserId();
    this.language = localStorage.getItem('lang') || 'ar';
  }

  ngOnInit() {
    this.getMyCourses();
  }

  getMyCourses() {
    this.userService.getMyCourses().subscribe((res: any) => {
      const rawCourses = res.body as any[];

      // Merge API data with static metadata
      this.courses = rawCourses.map(course => {
        const staticInfo = this.courseStaticData[course.name] ?? {
          titleTr: course.description,       
          summary: '',
          imageIconPath: './assets/Al-Bershama/media/homeComponents/service/default.webp',
          imageAlt: course.name
        };

        return {
          ...course,
          ...staticInfo,
          price: `${course.amount} جنيه`,
          btnText:'ابدا الكورس'
        };
      });
    });
  }

getDetailsUrl(course: any): void {
  const name = course.name.replace('-course', '');
  const url = `/${this.language}/course/${name}`;
  this.router.navigateByUrl(url);
}
}